import { useTranslation } from "react-i18next";
import { getTranslationText } from "utilities/translation-utilities";

const InputLabel = (props: {label?: string | React.ReactNode | boolean, required?: boolean, className?: string, removeDoublePoints?: boolean}) => {
    const [t] = useTranslation();
    
    if(typeof props.label == 'boolean') return <></>;

    let labelJsx = <></>;
    if (typeof props.label == 'string') {
        let label = getTranslationText(props.label, t);
        const labelClassName = `input-label ${props.className || ''}`.trim();
        const doublePoints = !props.removeDoublePoints ? ':' : <></>;
        labelJsx = (
            <div className={labelClassName}>
                {label}{props.required ? ' *' : ''}{doublePoints}
            </div>
        );
    }

    return labelJsx;
};

export default InputLabel;
